import type {AppThunk} from '../../../../actions/types'
import type {LoadedEndpoints} from '../../../../routes/loadEndpoint'

import {preloadFavoriteAgentPools} from './FavoriteAgentPools/FavoriteAgentPools.preload'

export const preloadFavoriteAgentPoolsPage = (): AppThunk<LoadedEndpoints> => dispatch => [
  ...dispatch(preloadFavoriteAgentPools()),
]
